<template>
    <div class="container bg-light mb-3" style="margin: 10px;">

        <h1>The Bawl_Zapher Wiki</h1>
        <p>
            Explore the depths of knowledge at the <span class="funky emphasize">Bawl_Zapher Wiki</span>! This essential resource is the
            heart of our community, offering an exhaustive guide that covers every detail—from hidden 
            lore and obscure secrets to the key strategies needed to dominate. We invite you to dive 
            into its pages to discover new insights, contribute your own findings, and connect with 
            fellow enthusiasts who share your passion. Don't get left behind; consult the Official <span class="funky emphasize">Bawl_Zapher</span> 
            Wiki to become a true expert before the event kicks off!
        </p>
        <a target="_blank" href="https://bawlzapher.miraheze.org/wiki/Main_Page" style="text-align: center; align-self: center;">Bawl_Zapher Wiki!</a>
    </div>
    <br>
    <div class="container" style="align-items: center;">
        <router-link to="/" class="btn btn-primary" style="align-self: center;">Go back to the start</router-link>
    </div>
</template>

<style>
.emphasize{
    text-decoration: underline !important;
    text-decoration-color: red;
}
.funky{
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}
</style>